export function ScrollIndicator() {
  return (
    <div className="flex flex-col items-center gap-3" aria-hidden="true">
      <div className="ow-scroll-track">
        <span className="ow-scroll-dot" />
      </div>
      <span
        className="font-display text-gold uppercase"
        style={{ fontSize: '10px', letterSpacing: '0.4em' }}
      >
        Scroll
      </span>
    </div>
  );
}
